import { useState } from 'react';
import { getResponsiveTextClasses } from '@/lib/responsive-utils';

interface ProjectCategory {
  id: string;
  title: string;
  image: string;
}

const projectCategories: ProjectCategory[] = [
  {
    id: 'aeropuertos',
    title: 'Aeropuertos',
    image: '/projects/01_Proyectos_Aeropuerto.png'
  },
  {
    id: 'termoelectricas',
    title: 'Termoeléctricas',
    image: '/projects/01_Proyectos_Termoelectrica.png'
  },
  {
    id: 'viaductos',
    title: 'Viaductos Elevados',
    image: '/projects/01_Proyectos_ViaductoE.png'
  },
  {
    id: 'vias-ferreas',
    title: 'Vías Férreas',
    image: '/projects/01_Proyectos_ViasF.png'
  },
  {
    id: 'vias-terrestres',
    title: 'Vías Terrestres',
    image: '/projects/01_Proyectos_ViasT.png'
  },
  {
    id: 'centros-comerciales',
    title: 'Centros Comerciales',
    image: '/projects/01_Proyectos_Centro.png'
  },
  {
    id: 'edificios-mixtos',
    title: 'Edificios Mixtos',
    image: '/projects/01_Proyectos_Edificios.png'
  },
  {
    id: 'naves-industriales',
    title: 'Naves Industriales',
    image: '/projects/01_Proyectos_Nave-Industrial.png'
  }
];

interface ProjectExpertiseProps {
  className?: string;
}

export function ProjectExpertise({ className = '' }: ProjectExpertiseProps) {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <section className={`py-16 lg:py-20 bg-white ${className}`}>
      {/* Header Section - with container */}
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <div className="text-center">
          {/* Badge */}
           <div className="inline-flex items-center gap-2 text-liec-primary-500 font-semibold text-sm uppercase tracking-wider mb-6">
            PROYECTOS CLAVE
          </div>
          <svg className='inline-flex items-center gap-2 ml-2' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="0.330774" y1="5.41623" x2="11.9289" y2="11.1156" stroke="#E34C0E" stroke-width="1.5"/>
          <path d="M6.36253 13.292L12.4163 11.2088L10.5026 4.91892" stroke="#E34C0E" stroke-width="1.5"/>
          </svg>


          {/* Heading */}
          <h2 className={getResponsiveTextClasses(
            'text-2xl font-bold text-liec-neutral-900 mb-4',
            'text-3xl',
            'text-4xl'
          )}>
            Nuestro Expertis
          </h2>

          {/* Description */}
          <p className={`${getResponsiveTextClasses('text-base', 'text-lg', 'text-lg')} text-liec-neutral-600 max-w-4xl mx-auto`}>
            En LIEC, nuestros proyectos destacan por su compromiso con la calidad e innovación en ingeniería de materiales,
            fruto de la colaboración con nuestros clientes y el uso de tecnología avanzada.
          </p>
        </div>
      </div>

      {/* Grid Section - Full width, no container */}
      <div className="w-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {projectCategories.map((category) => (
            <div
              key={category.id}
              className="relative aspect-[4/2] overflow-hidden group cursor-pointer"
             // onMouseEnter={() => setHoveredId(category.id)}
              //onMouseLeave={() => setHoveredId(null)}
            >
              {/* Background Image */}
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-out group-hover:scale-110"
                style={{
                  backgroundImage: `url(${category.image})`
                }}
              />

              {/* Overlay */}
              <div className={`absolute inset-0 bg-gradient-to-t from-black/40 via-black/20 to-transparent transition-opacity duration-300 ${
                hoveredId === category.id ? 'opacity-50' : 'opacity-40'
              }`} />

              {/* Content */}
              <div className="absolute inset-0 flex items-center justify-center p-6">
                <div className="text-center">
                  <h3 className={`${getResponsiveTextClasses(
                    'text-xl',
                    'text-2xl',
                    'text-2xl'
                  )} font-medium text-white transition-all duration-300 ${
                    hoveredId === category.id ? 'transform scale-110' : ''
                  }`}>
                    {category.title}
                  </h3>
                  
                  {/* Decorative line */}
                  <div className={`w-12 h-1 bg-liec-primary-500 mx-auto mt-4 transition-all duration-300 ${
                    hoveredId === category.id ? 'w-20' : ''
                  }`} />
                </div>
              </div>

              {/* Hover Border Effect */}
              <div className={`absolute inset-0 border-4 border-liec-primary-500 transition-opacity duration-300 ${
                hoveredId === category.id ? 'opacity-100' : 'opacity-0'
              }`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
